import { yupResolver } from '@hookform/resolvers/yup';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { Fab } from '@mui/material';
import { Box } from '@mui/system';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { CreateTagDto, TagDto } from '../../common/PricePrgClient';
import { FormTextField } from '../../common/form';
import { FormColorPicker } from '../../common/form/FormColorPicker';
import { showConfirmDialog } from '../ui/redux/uiSlices';
import { createTag, deleteTag, updateTag } from './redux/tagSlices';
type Props = {
    tag: TagDto;
};

const schema: yup.SchemaOf<CreateTagDto> = yup.object().shape({
    name: yup.string().required().max(60).label('Name'),
    shortName: yup.string().required().max(4).label('Short name'),
    color: yup.string().required().max(10).label('Color')
});
export const TagRow = ({ tag }: Props) => {
    const dispatch = useDispatch();
    const { handleSubmit, control } = useForm<CreateTagDto>({
        resolver: yupResolver(schema),
        defaultValues: tag
    });

    const onSubmit = (request: CreateTagDto) => {
        if (!tag.tagId) {
            dispatch(createTag.request(request));
        } else {
            dispatch(
                updateTag.request({
                    ...request,
                    tagId: tag.tagId
                })
            );
        }
    };

    const handleDelete = () => {
        dispatch(
            showConfirmDialog({
                dialogMessage: 'Do you want to delete the tag?',
                dialogTitle: 'Delete tag',
                okAction: deleteTag.request(tag.tagId),
                primaryActionName: 'Delete'
            })
        );
    };

    return (
        <Box>
            <FormTextField sx={{ padding: 1 }} label="Name" control={control} name="name" />
            <FormTextField sx={{ padding: 1 }} control={control} name="shortName" label="Short name" />

            <Box sx={{ display: 'inline-flex', mt: 4, mx: 1 }}>
                <FormColorPicker control={control} name="color" />
            </Box>
            <Fab sx={{ mt: 0, mx: 1 }} size="small" color="primary" onClick={handleSubmit(onSubmit)}>
                <SaveIcon />
            </Fab>
            <Fab sx={{ mx: 1 }} size="small" color="error" onClick={handleDelete}>
                <DeleteIcon />
            </Fab>
        </Box>
    );
};
